import { Flex } from '@mantine/core'
import { clsx } from 'clsx'
import { useContext } from 'react'

import { useAnalytics } from '@flecto/analytics'
import { type ParameterID, type CoreBookingDocument } from '@flecto/types'
import { Modal } from '@flecto/ui'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'
import { ModalsContext } from '@flecto/ui/src/components/Modal/ModalsProvider'

import { useBookingStore } from '../../../booking-details/hooks/useBookingStore'
import { useBookingDocumentActions } from '../../hooks/useBookingDocumentActions'
import { UploadDocumentCard } from '../UploadDocumentCard/UploadDocumentCard'
import styles from './styles.module.css'

export interface ModalViewSingleDocumentProps {
  documentId: ParameterID
  id?: ParameterID
}

export function ModalViewSingleDocument({
  documentId,
  id,
}: Readonly<ModalViewSingleDocumentProps>) {
  const { closeModal } = useContext(ModalsContext)
  const { change, view, deleteDocument } = useBookingDocumentActions()
  const { isMobile } = useMediaQuery()
  const track = useAnalytics('segment')
  const { documents: data } = useBookingStore()

  const file = data?.find((item) => item.id === documentId)

  if (!file) return null

  const handleView = (file: CoreBookingDocument) => {
    view(file?.url)
    track('BOOKING_DOCUMENT__VIEW', {
      booking_id: id ?? '',
      filename: file?.filename_base ?? '',
      type: file?.type ?? '',
      category: file?.category ?? '',
      generated: file.generated ?? false,
    })
  }

  return (
    <Modal size={isMobile ? 'md' : 'xxl'} variant='default'>
      <Modal.Close />
      <Modal.Title>
        <Flex
          gap={'sm'}
          align={'flex-end'}
          className={clsx({
            [styles.titleMobile]: isMobile,
            [styles.title]: !isMobile,
          })}
        >
          {file.filename_base}
        </Flex>
      </Modal.Title>
      <Modal.Content>
        <Flex direction={'column'} gap={'md'}>
          <UploadDocumentCard
            key={file.id}
            document={file}
            onView={() => handleView(file)}
            onDelete={() => {
              deleteDocument(file.id as string)
              closeModal()
            }}
            onChange={(field, value) => {
              change(file.id as string, field, value)
            }}
          />
        </Flex>
      </Modal.Content>
    </Modal>
  )
}
